import HappyBirthday20230522Screen from "./HappyBirthday20230522Screen";

export default HappyBirthday20230522Screen;